import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api";
import { ArrowLeft, Loader2, MapPin } from "lucide-react";
import EventDayGroups from "../components/EventDayGroups";
import { applyMeta } from "../lib/meta";

export default function CityPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/city/${slug}`).then(({ data }) => {
      setData(data);
      applyMeta({
        title: `Events in ${data.city.name} · TicketsPro.app`,
        description: `What's on in ${data.city.name}? Discover and book upcoming events near you on TicketsPro — browse dates, venues and ticket prices.`,
      });
    }).catch(() => setErr(true));
  }, [slug]);

  const cityName = data?.city?.name || "";

  return (
    <div className="min-h-screen bg-[#0d1626]" data-testid="city-page">
      <div className="border-b border-white/10">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-white/80 hover:text-white flex items-center gap-1.5 text-sm font-medium"><ArrowLeft size={16} /> Home</Link>
          <span className="text-white font-bold">TicketsPro.app</span>
        </div>
      </div>

      {err ? (
        <div className="max-w-5xl mx-auto px-6 py-24 text-center" data-testid="city-not-found">
          <p className="text-[#8a97a8]">We couldn't find that city.</p>
          <Link to="/events" className="inline-block mt-4 text-[#2ec9c9] hover:underline">Browse all events</Link>
        </div>
      ) : data === null ? (
        <div className="py-24 flex justify-center"><Loader2 className="animate-spin text-[#2ec9c9]" size={32} /></div>
      ) : (
        <>
          <div className="relative overflow-hidden border-b border-white/10" data-testid="city-hero"
            style={{ background: "linear-gradient(135deg, #123a3a, #0d1626 70%)" }}>
            <div className="absolute -right-16 -top-16 w-72 h-72 rounded-full bg-[#2ec9c9]/10 blur-3xl" />
            <div className="relative max-w-5xl mx-auto px-6 py-16">
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 rounded-xl flex items-center justify-center bg-[#2ec9c9]/20 text-[#2ec9c9]"><MapPin size={24} /></span>
                <div>
                  <p className="text-sm uppercase tracking-wide text-[#2ec9c9]">Events near you</p>
                  <h1 className="text-3xl sm:text-5xl font-bold text-white">Events in {cityName}</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-5xl mx-auto px-6 py-12">
            {(data.events || []).length === 0 ? (
              <div className="py-20 text-center" data-testid="city-empty">
                <p className="text-[#8a97a8]">No upcoming events in {cityName} right now.</p>
                <Link to="/events" className="inline-block mt-4 text-[#2ec9c9] hover:underline">Browse all events</Link>
              </div>
            ) : (
              <EventDayGroups events={data.events} testidPrefix="city" />
            )}
          </div>
        </>
      )}
    </div>
  );
}
